import axios from "axios"
import {getField, updateField} from 'vuex-map-fields'
import i18n from '@/i18n'

const defaultState = {
  step: 1,
  authorization_key: '',
  authorization_id: '',
  complaint: {
      id: '',
      /* STEP 0*/
      terms: '',

      /* STEP 1 */
      reservation_number: '', // QWE123W
      // required
      client_informed: 1,
      // required (optional fi or se)
      contacted_airline: undefined, // nil/true/false

      /* STEP 2 */
      name: '', // Jack London
      email: '', // jlondon@gmail.com

      /* STEP 3 */
      passport_needed: false,
      people: 1,
      source_origin: "",

      affiliate_tracked: false,
      least_one_poa_signed: false,
      travel_plan_ok: false,
  },
  currencies: [],
  countriesCodes: []
}

const ignoredSteps = function(state) {

  let stepsArr = []
  if (!state.complaint.passport_needed) {
    stepsArr.push(3);
    if (state.complaint.source_origin == "gf_insurance") {
      stepsArr.push(4);
    }
  }
  return stepsArr;
}

const actions = {

  getAuthorization(context, payload){
    let {auth_key} = payload
    return new Promise((resolve, reject) => {
      axios.get(`/authorizations/${auth_key}.json`)
        .then(({data}) => {
          if(data.success){
            context.commit('FETCH', data.authorization)
            if (data.authorization.sign_owner_url){
              data.authorization.relevant_owner_poa.sign_owner_url = data.authorization.sign_owner_url
              context.commit('signseal/FETCH_POA', data.authorization.relevant_owner_poa, { root: true })
            } else {
              context.commit('signseal/updateField', { path: `poa.processing`, value: false }, { root: true })
            }
            context.commit('documents/FETCH', data.authorization.separate_documents, { root: true })
            context.commit('expenses/FETCH', data.authorization.extra_expenses, { root: true })
            context.commit('travelers/FETCH', {
              list: data.authorization.complaint.travelers,
              people: data.authorization.complaint.people
            }, { root: true })
            return resolve("The case is uploaded successfully")
          }else{
            return reject("getAutthorization fail -> success: false")
          }
        })
        .catch((errors) => {
          console.error(errors)
          return reject("getAutthorization fail -> " + errors)
        })
      })
  },

  getComplaint(context, auth_key) {
    return new Promise((resolve, reject) => {
      axios.get(`/authorizations/${auth_key}/complaint.json`)
        .then(response => {
          if (response.data) {
            context.commit('FETCH_COMPLAINT', response.data);
            context.commit('travelers/FETCH', {
              list: response.data.travelers,
              people: response.data.people
            }, { root: true });
            resolve(response);
          } else {
            reject("Fetch failed: Complaint data not found");
          }
        })
        .catch(error => {
          console.error(error);
          reject("Fetch failed with error: " + error);
        });
    });
  },

  putComplaint({ state }, updatedFields) {
    return new Promise((resolve, reject) => {
      console.log("putComplaint", state.complaint.id, updatedFields);
      axios.put(`/complaints/${state.complaint.id}`, updatedFields)
        .then(response => {
          if(response.data.success){
            resolve("Complaint updated successfully");
          } else {
            reject("Update failed: success flag false");
          }
        })
        .catch(error => {
          reject("Update failed with error: " + error);
        });
    });
  },

  putAuthorization(context, formData){
    return new Promise((resolve, reject) => {
      axios.put(`/authorizations/${context.state.authorization_key}.json`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
      }).then(({ data }) => {
        if (data.success) {
          context.commit('FETCH', data.authorization)
          context.commit('documents/FETCH', data.authorization.separate_documents, { root: true })
          context.commit('travelers/FETCH', {
            list: data.authorization.complaint.travelers,
            people: data.authorization.complaint.people
          }, { root: true })
          context.commit('expenses/FETCH', data.authorization.extra_expenses, { root: true })
          return resolve("The case is updated successfully")
        } else {
          return reject("putAuthorization fail -> success: false")
        }
      }).catch((errors) => {
        return reject(errors)
      })
    })
  }
}

const mutations = {

  updateField,

  UPDATE_COMPLAINT_FIELD(state, payload){
    updateField(state.complaint, payload)
  },

  PREV_STEP(state) {
    let ignoredSteps = state.ignoredSteps;
    let i;
    for (i = state.step - 1; i > 0; i--) {
      if (!ignoredSteps.includes(i)) {
        state.step = i;
        break;
      }
    }
  },

  NEXT_STEP(state) {
    let ignoredSteps = state.ignoredSteps;
    let i;
    for (i = state.step + 1; i < 6; i++) {
      if (!ignoredSteps.includes(i)) {
        state.step = i;
        break;
      }
    }
  },

  FETCH(state, data) {
    state.authorization_key = data.uploads_key
    state.authorization_id = data.id
    state.complaint.id = data.complaint.id || ''
    state.complaint.reservation_number = data.complaint.reservation_number || ''
    state.complaint.client_informed = data.complaint.client_informed || 1
    if (data.complaint.contacted_airline != null) {
      state.complaint.contacted_airline = data.complaint.contacted_airline
    }
    state.complaint.name = data.complaint.name || ''
    state.complaint.email = data.complaint.email || ''
    state.complaint.address = data.complaint.address || ''
    state.complaint.zip_code = data.complaint.zip_code || ''
    state.complaint.city = data.complaint.city || ''
    state.complaint.country = data.complaint.country || ''
    state.complaint.terms = data.complaint.terms || false

    state.complaint.passport_needed = data.complaint['passport_needed?']
    state.complaint.people = data.complaint.people
    state.complaint.source_origin = data.complaint.source_origin
    state.complaint.affiliate_tracked = data.complaint.affiliate_tracked
    state.complaint.least_one_poa_signed = data.complaint["least_one_poa_signed?"]
    state.complaint.travel_plan_ok = data.complaint["travel_plan_ok?"]

    state.ignoredSteps = ignoredSteps(state)
  },

  FETCH_COMPLAINT(state, complaintData) {
    state.complaint = { ...state.complaint, ...complaintData };
  }
}

const getters = {

  getField,

  getComplaintField(state) {
    return getField(state.complaint)
  },

  currencies: state => state.currencies,

  informedMapper: () => {
    return {
      1: i18n.t('f_when_informed_1'),
      2: i18n.t('f_when_informed_2'),
      3: i18n.t('f_when_informed_3')
    }
  },

  r2s0FormData: (state, getters, rootState) => {
    let formData = new FormData()
    formData.append(`complaint[people]`, rootState.travelers.people)
    formData.append('complaint[name]', state.complaint.name)

    formData.append('complaint[address]', state.complaint.address)
    formData.append(`complaint[zip_code]`, state.complaint.zip_code)
    formData.append(`complaint[city]`, state.complaint.city)
    formData.append(`complaint[country]`, state.complaint.country)
    formData.append(`complaint[terms]`, state.complaint.terms)
    rootState.travelers.list.forEach((traveler, i) => {
      if (!traveler['for_attach']) {
        formData.append(`complaint[travelers_attributes][${i}][id]`, traveler['id'])
      }
      if (traveler['for_destroy']) {
        formData.append(`complaint[travelers_attributes][${i}][_destroy]`, traveler['for_destroy'])
      }else{
        formData.append(`complaint[travelers_attributes][${i}][name]`, traveler['name'])
        formData.append(`complaint[travelers_attributes][${i}][email]`, traveler['email'])
        formData.append(`complaint[travelers_attributes][${i}][is_adult]`, traveler['is_adult'])
        formData.append(`complaint[travelers_attributes][${i}][parent_name]`, traveler['parent_name'])
        formData.append(`complaint[travelers_attributes][${i}][parent_email]`, traveler['parent_email'])
      }
    })

    return formData
  },

  r2s1FormData: (state, getters, rootState, rootGetters) => {
    let formData = new FormData()
    formData.append('complaint[reservation_number]', state.complaint.reservation_number)
    formData.append('complaint[client_informed]', state.complaint.client_informed)
    formData.append(`complaint[contacted_airline]`, state.complaint.contacted_airline)
    formData.append(`complaint[authorization_attributes][id]`, state.authorization_id)
    let docs_key = "complaint[authorization_attributes][separate_documents_attributes]"
    rootGetters['documents/tickets'].map((ticket, i) => {
      if (ticket['for_destroy']) {
        formData.append(`${docs_key}[${i}][id]`, ticket['id'])
        formData.append(`${docs_key}[${i}][_destroy]`, ticket['for_destroy'])
      }
      if (ticket['for_attach']){
        formData.append(`${docs_key}[${i}][doc]`, ticket['doc'])
        formData.append(`${docs_key}[${i}][doc_type]`, ticket['doc_type'])
      }
    })
    return formData
  },

  r2s2FormData: (state, getters, rootState) => {
    let formData = new FormData()

    formData.append(`complaint[people]`, rootState.travelers.people)
    formData.append(`complaint[name]`, state.complaint.name)
    formData.append(`complaint[email]`, state.complaint.email)
    rootState.travelers.list.map((traveler, i) => {
      if (!traveler['for_attach']) {
        formData.append(`complaint[travelers_attributes][${i}][id]`, traveler['id'])
      }
      if (traveler['for_destroy']) {
        formData.append(`complaint[travelers_attributes][${i}][_destroy]`, traveler['for_destroy'])
      }else{
        formData.append(`complaint[travelers_attributes][${i}][name]`, traveler['name'])
        formData.append(`complaint[travelers_attributes][${i}][email]`, traveler['email'])
        formData.append(`complaint[travelers_attributes][${i}][is_adult]`, traveler['is_adult'])
        formData.append(`complaint[travelers_attributes][${i}][parent_name]`, traveler['parent_name'])
        formData.append(`complaint[travelers_attributes][${i}][parent_email]`, traveler['parent_email'])
      }
    })
    return formData
  },

  r2s3FormData: (state, getters, rootState, rootGetters) => {
    let formData = new FormData()
    formData.append(`complaint[authorization_attributes][id]`, state.authorization_id)
    let docs_key = "complaint[authorization_attributes][separate_documents_attributes]"
    rootGetters['documents/passports'].map((passport, i) => {
      if (passport['for_destroy']) {
        formData.append(`${docs_key}[${i}][id]`, passport['id'])
        formData.append(`${docs_key}[${i}][_destroy]`, passport['for_destroy'])
      }
      if (passport['for_attach']){  
        formData.append(`${docs_key}[${i}][doc]`, passport['doc'])
        formData.append(`${docs_key}[${i}][doc_type]`, passport['doc_type'])
      }
    })
    return formData
  },

  r2s4FormData: (state, getters, rootState) => {
    let formData = new FormData()
    formData.append(`complaint[authorization_attributes][id]`, state.authorization_id)
    let expenses_key = "complaint[authorization_attributes][extra_expenses_attributes]"
    rootState.expenses.list.map((expense, i) => {
      if (!expense['for_attach']) {
        formData.append(`${expenses_key}[${i}][id]`, expense['id'])
      }
      if (expense['for_destroy']) {
        formData.append(`${expenses_key}[${i}][_destroy]`, expense['for_destroy'])
      }else{
        if (expense['receipt']['doc']) {
          formData.append(`${expenses_key}[${i}][receipt]`, expense['receipt']['doc'])
        }
        formData.append(`${expenses_key}[${i}][cost_type]`, expense['cost_type'])
        formData.append(`${expenses_key}[${i}][cost_description]`, expense['cost_description'])
        formData.append(`${expenses_key}[${i}][amount]`, expense['amount'])
        formData.append(`${expenses_key}[${i}][currency]`, expense['currency'])
      }
    })
    return formData
  }
}

export default {
  namespaced: true,
  state: defaultState,
  actions: actions,
  mutations: mutations,
  getters: getters
}
